<template>
  <v-row class="ma-0 mt-5">
    <v-col cols="12" class="py-5 px-6">
      <div class="img-wrap">
        <v-img
          class="mx-auto search-none-img"
          src="@/assets/img/search_none.png"
        ></v-img>
      </div>
      <p class="mt-4 mb-0 text-center" style="font-size: 15px">
        {{ $t(text) }}
      </p>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: '검색결과가 없습니다.',
    },
  },
};
</script>

<style scoped>
.search-none-img {
  width: 70px;
  height: 70px;
  color: grey;
}
</style>
